import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";

const MapSection = () => (
  <ScrollableAnchor id="location">
      <section className="content-section bg-dark text-white text-center animatedParent animateOnce"
               data-sequence='500'>
          <div className="container">
              <div className="content-section-heading text-center">
                  <h3 className="text-secondary mb-0">Anfahrt</h3>
                  <h2 className="mb-5">Wo ihr uns findet</h2>
              </div>
              <div className="animated fadeInDownShort" data-id="1">
                  <h4 className="text-center">MEDI Zentrum<br/>Schollenäcker 2<br/>74538 Rosengarten-Uttenhofen</h4>
              </div>
          </div>
          <iframe
              className="map margin-top animated fadeInDownShort"
              data-id="2"
              title="where-we-are-located"
              width="70%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=74538%20Rosengarten-Uttenhofen,%20Schollen%C3%A4cker%202+(Medi-Zentrum)&amp;t=h&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          />
          <br/>
      </section>
  </ScrollableAnchor>
);
export default MapSection;


// WEBPACK FOOTER //
// ./src/main/map.js